<template>
  <MainLayout>
    <div class="slot-body">
      <div class="container">
        <div class="column pt-5 align-items-center justify-content-center">
          <div class="col-12 d-flex align-items-center justify-content-center">
            <span class="title">
              {{ translate.title }}
            </span>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-center">
            <span class="subtitle">
              {{ translate.subtitle }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from '../layouts/MainLayout.vue';
import { computed } from 'vue';
import { localeStore } from 'stores/locale'
import { useHead } from '@unhead/vue';
import router from '../../router';

const store = localeStore()

const tradutores = {
    portugues: {
        title: 'Erro 404',
        subtitle: 'Página não encontrada!'
    },
    ingles: {
        title: 'Error 404',
        subtitle: 'Page not found!'
    }
}

const translate = computed(() => store.locale == 'pt-br' ? tradutores.portugues : tradutores.ingles)

useHead({
    templateParams: {
        subTitle: null, 
        subPage: translate.value.title,
        page_url: window.location.origin + router.currentRoute.value.fullPath,
        page_description: store.locale == 'pt-br' ?
            `Mais de 10.000 minutos de vídeos publicados com as mais belas e TOPs modelos.` :
            `More than 10,000 minutes of videos published with the most beautiful and TOP models.`,
        page_image: '/favicon.ico',
        page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: store.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/404",
        page_url_en: "https://belladasemana.com.br/en/404",
        page_canonical: "https://belladasemana.com.br/"+store.locale+"/404",        
    }
})

</script>
<style scoped lang="css">
.slot-body {
    margin-top: 65px !important;  
    background-color: #fff !important;
    height: 50vh;
}

.title {
    font-family: 'Bebas-Neue-Light';
    height: 77px;
    color: #000000;
    font-size: 64px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 77px;
}

.subtitle {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

.container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media screen and (max-width: 769px) {
    .title {
        font-family: 'Bebas-Neue-Light';
        height: 77px;
        color: #000000;
        font-size: 44px;
        font-weight: 300;
        letter-spacing: 0;
        line-height: 77px;
    }
}
</style>
